var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.8748,
    cy: 61.1248,
    r: 60.4998,
    fill: "#FE42FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4035 55.4588C81.3686 55.469 76.4573 53.9225 72.3645 51.0357V71.1593C72.3611 81.2661 64.0361 89.4574 53.7698 89.454C43.5036 89.4506 35.1831 81.2549 35.1865 71.148C35.19 61.0412 43.515 52.85 53.7812 52.8533C54.6364 52.8533 55.4892 52.9119 56.3364 53.0278V63.1459C51.8435 61.7536 47.0544 64.2106 45.6403 68.6337C44.2261 73.0569 46.7218 77.7715 51.2147 79.1637C55.7076 80.5559 60.4966 78.099 61.9108 73.6759C62.1714 72.8621 62.3041 72.0135 62.3041 71.1593V31.835H72.3645C72.3588 32.6723 72.432 33.5086 72.5817 34.3335C73.2894 38.0476 75.5176 41.3126 78.7438 43.3599C81.0165 44.8377 83.6803 45.6244 86.4035 45.6221V55.4588Z",
    fill: "#FAD414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtIcon);
export default __webpack_public_path__ + "static/media/tt-icon.ef61026b1dad3c7fc0738213f4091296.svg";
export { ForwardRef as ReactComponent };